
import {PostCardProps} from 'components/blog/PostCard';
import {cmsEnv} from 'creates/env';
import {graphql, useStaticQuery} from 'gatsby';

import {parsePosts} from './parsers';
import {QueryResult} from './types';

const query = graphql`
{
	posts: allAirtable(
		filter: {
			table: {
				eq: "Posts"
			}
			data: {
				Topics: {
					glob: "*Most Popular*"
				}
			}
		}
		sort: {
			rowIndex: DESC
		}
    	limit: 10
  	) {
		nodes {
			data {
				...PostFields

				# Using images here since we've already
				# filtered to only 10 popular posts
				...PostImages
			}
		}
	}
}`;

export const usePopular = (): PostCardProps[] => {
	const {posts: {nodes}} = useStaticQuery<QueryResult>(query);
	const env = cmsEnv();

	const posts = nodes
		.map(({data}) => data)
		.filter(({envs}) => envs.includes(env));

	return parsePosts(posts);
};
